
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import router from "@/router"
import RouteNames from "@/util/route_names"
import OeffnungLabel from "./sub/OeffnungLabel.vue"
import FilialeMainLogic from "@/logic/bestellung_neu/filiale_main_logic"
import ErrorBox from "../custom/ErrorBox.vue"
import BestellungRow from "../custom/BestellungRow.vue"
import BestellungRowAbholung from "../custom/BestellungRowAbholung.vue"
import BestellungRowLieferung from "../custom/BestellungRowLieferung.vue"
import BestellungRowSofort from "../custom/BestellungRowSofort.vue"
import ReservierungRow from "../custom/ReservierungRow.vue"

@Component({
  components: {
    FilialeHeader,
    OeffnungLabel,
    ErrorBox,
    BestellungRow,
    BestellungRowAbholung,
    BestellungRowLieferung,
    BestellungRowSofort,
    ReservierungRow
  },
})
export default class FilialeMain extends mixins(Calculator) {
  logic: FilialeMainLogic = null

  bestellungAnzeigen(element: any) {
    this.logic.bestellungAnzeigen(element)
  }

  reservierungAnzeigen(element: any) {
    this.logic.reservierungAnzeigen(element)
  }

  detailsAnzeigen() {
    router.push({ name: RouteNames.NEU.INFO_PAGE })
  }

  mounted() {
    this.logic = new FilialeMainLogic()
    this.logic.init()
  }

  lieferungWaehlen() {
    this.logic.lieferungWaehlen()
  }

  abholungWaehlen() {
    this.logic.abholungWaehlen()
  }

  reservierungWaehlen() {
    this.logic.reservierungWaehlen()
  }

  sofortbestellungWaehlen() {
    this.logic.sofortbestellungWaehlen()
  }

  // bestellungAnzeigen(bestellung: Bestellung) {
  //   this.logic.bestellungAnzeigen(bestellung)
  // }
}
